const collaboratorsActions = {
  UPDATE_CHECKBOX_FILTERS: 'UPDATE_CHECKBOX_FILTERS',
  IS_LOADING: 'IS_LOADING',
  IS_SEARCHING: 'IS_SEARCHING',
  UPDATE_SEARCH_VALUE: 'UPDATE_SEARCH_VALUE',
  UPDATE_QUERY_PARAMS: 'UPDATE_QUERY_PARAMS',
  UPDATE_PAGINATION: 'UPDATE_PAGINATION',
  UPDATE_VAULTS: 'UPDATE_VAULTS',
  SET_REFETCH_COLLABORATORS: 'SET_REFETCH_COLLABORATORS',
  UPDATE_COLLABORATOR: 'UPDATE_COLLABORATOR',
};

export { collaboratorsActions };
